// extracted by mini-css-extract-plugin
module.exports = {"overlayItem":"OverlayItem_overlayItem_3vjHF","question":"OverlayItem_question_1x3Nc","open":"OverlayItem_open_1BBDJ","answer":"OverlayItem_answer_3c-od"};